import _ from 'lodash';

function Main2Ctrl($rootScope, $scope, $element, $state, ChartGeneratorService, PlayerService, AnalysisService, PlanService) {
  'ngInject';

  window['scope'] = $scope;

  const h337 = require('heatmap.js');
  const Flatpickr = require('flatpickr');
  const Korean = require("flatpickr/dist/l10n/ko.js").ko;

  // ViewModel
  const vm = this;

      // sidebar 초기화
      $rootScope.$emit('base:sidebarEvent', 'open');

      
  let number_format = d3.format(',');

  //현재 page명 세팅
  $scope.$parent.base.pageStatus = 'playerMain';

  /**
   * 접속자 - 정보 파라미터
   * user_id : 사용자 ID
   * mode : ingame(경기중)/recent(최근, default)/previous(이전)/today(오늘)/yesterday(어제)
   *        weekly(주간)/monthly(월간)/yearly(연간)
   */
  if(!$rootScope.selectPlayerInfo){
    $state.go('Service.main');
  }
  vm.userInfo = {
    user_id: $rootScope.selectPlayerInfo.user_id,
    mode: ''
  };

  // 히트맵 탭모드 초기화
  vm.activeHeatmapTab = 'att';
  // 히트맵 포지션 정보
  vm.heatmapPos = {
    'A-CK-R' : {x:12, y: 12, radius:30},    //A면 코너킥 오른쪽 - A-CK-R
    'A-CK-L' : {x:12, y: 232, radius:30},   //A면 코너킥 왼쪽 - A-CK-L
    'B-CK-L' : {x:308, y: 232, radius:30},  //B면 코너킥 왼쪽 - B-CK-L
    'B-CK-L' : {x:308, y: 12, radius:30},   //B면 코너킥 왼쪽 - B-CK-L
    //코너킥 -end
    //오른쪽 -start
    'A-PA-CK-R' : {x:33, y: 30, radius:30},   //A면 페널티 에어리어 코너 부근 오른쪽 - A-PA-CK-R
    'A-AK-TL-R' : {x:95, y: 30, radius:30},   //A면 아크서클 터치라인 부근 오른쪽 - A-AK-TL-R
    'A-MF-TL-R' :  {x:120, y: 30, radius:30},   //A면 미드필드 터치라인 부근 오른쪽 - A-MF-TL-R
    'A-HL-TL-R' : {x:150, y: 30, radius:30},   //A면 하프라인 터치라인 부근 오른쪽 - A-HL-TL-R
    'B-PA-CK-R' : {x:320-33, y: 30, radius:30},   //B면 페널티 에어리어 코너 부근 오른쪽 - B-PA-CK-R
    'B-AK-TL-R' : {x:320-95, y: 30, radius:30},   //B면 아크서클 터치라인 부근 오른쪽 - B-AK-TL-R
    'B-MF-TL-R' : {x:320-120, y: 30, radius:30},   //B면 미드필드 터치라인 부근 오른쪽 - B-MF-TL-R
    'B-HL-TL-R' : {x:320-150, y: 30, radius:30},   //B면 하프라인 터치라인 부근 오른쪽 - B-HL-TL-R
    'A-PA-OUT-EL-R' : {x:18, y: 44, radius:30},   //A면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽 - A-PA-OUT-EL-R
    'A-PA-OUT-SD-R' : {x:57, y: 44, radius:30},   //A면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽 - A-PA-OUT-SD-R
    'B-PA-OUT-EL-R' : {x:320-18, y: 44, radius:30},   //B면 페널티 에어리어 바깥쪽 엔드라인 부근 오른쪽 - B-PA-OUT-EL-R
    'B-PA-OUT-SD-R' : {x:320-57, y: 44, radius:30},   //B면 페널티 에어리어 바깥쪽 사이드 부근 오른쪽 - B-PA-OUT-SD-R
    'A-PA-IN-EL-R' : {x:18, y: 74, radius:30},   //A면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽 - A-PA-IN-EL-R
    'A-PA-OUT-FR-R' : {x:70, y: 74, radius:30},   //A면 페널티 에어리어 바깥쪽 정면 부근 오른쪽 - A-PA-OUT-FR-R
    'A-MF-R' : {x:120, y: 74, radius:30},   //A면 미드필드 부근 오른쪽 - A-MF-R
    'B-PA-IN-EL-R' : {x:320-18, y: 74, radius:30},   //B면 페널티 에어리어 안쪽 엔드라인 부근 오른쪽 - B-PA-IN-EL-R
    'B-PA-OUT-FR-R' : {x:320-70, y: 74, radius:30},   //B면 페널티 에어리어 바깥쪽 정면 부근 오른쪽 - B-PA-OUT-FR-R
    'B-MF-R' : {x:320-120, y: 74, radius:30},   //B면 미드필드 부근 오른쪽 - B-MF-R
    'A-GA-OUT-FR-R' : {x:40, y: 84, radius:30},   //A면 골 에어리어 바깥쪽 정면 부근 오른쪽 - A-GA-OUT-FR-R
    'A-HL-R' : {x:150, y: 84, radius:30},   //A면 하프라인 오른쪽 - A-HL-R
    'B-GA-OUT-FR-R' : {x:320-40, y: 84, radius:30},   //B면 골 에어리어 바깥쪽 정면 부근 오른쪽 - B-GA-OUT-FR-R
    'B-HL-R' : {x:320-150, y: 84, radius:30},   //B면 하프라인 오른쪽 - B-HL-R
    'A-GA-IN-EL-R' : {x:18, y: 102, radius:30},   //A면 골 에어리어 안쪽 엔드라인 오른쪽 - A-GA-IN-EL-R
    'A-GA-IN-R' : {x:27, y: 102, radius:30},   //A면 골 에어리어 안쪽 오른쪽 - A-GA-IN-R
    'A-PA-IN-FR-R' : {x:57, y: 102, radius:30},   //A면 페널티 에어리어 안쪽 정면 부근 오른쪽 - A-PA-IN-FR-R
    'A-AK-R' : {x:95, y: 102, radius:30},   //A면 아크서클 부근 오른쪽 - A-AK-R
    'B-GA-IN-EL-R' : {x:320-18, y: 102, radius:30},   //B면 골 에어리어 안쪽 엔드라인 오른쪽 - B-GA-IN-EL-R
    'B-GA-IN-R' : {x:320-27, y: 102, radius:30},   //B면 골 에어리어 안쪽 오른쪽 - B-GA-IN-R
    'B-PA-IN-FR-R' : {x:320-57, y: 102, radius:30},   //B면 페널티 에어리어 안쪽 정면 부근 오른쪽 - B-PA-IN-FR-R
    'B-AK-R' : {x:320-95, y: 102, radius:30},   //B면 아크서클 부근 오른쪽 - B-AK-R
    'A-GA-IN-GK-R' : {x:18, y: 112, radius:30},   //A면 골 에어리어 안쪽 골킥 부근 오른쪽 - A-GA-IN-GK-R
    'A-PK-R' : {x:48, y: 112, radius:30},   //A면 페널티킥 부근 오른쪽 - A-PK-R
    'B-GA-IN-GK-R' : {x:320-18, y: 112, radius:30},   //B면 골 에어리어 안쪽 골킥 부근 오른쪽 - B-GA-IN-GK-R
    'B-PK-R' : {x:320-48, y: 112, radius:30},   //B면 페널티킥 부근 오른쪽 - B-PK-R
    //오른쪽 -end
    //센터 -start
    'A-GA-IN-GK-C' : {x:18, y: 122, radius:30},   //A면 골 에어리어 안쪽 골킥 부근 가운데 - A-GA-IN-GK-C
    'A-GA-IN-C' : {x:27, y: 122, radius:30},   //A면 골 에어리어 안쪽 가운데 - A-GA-IN-C
    'A-GA-IN-C' :  {x:40, y: 122, radius:30},   //A면 골 에어리어 바깥쪽 정면 부근 가운데 - A-GA-IN-C
    'A-PK-C' : {x:48, y: 122, radius:30},   //A면 페널티킥 부근 가운데 - A-PK-C
    'A-PA-IN-FR-C' : {x:57, y: 122, radius:30},   //A면 페널티 에어리어 안쪽 정면 부근 가운데 - A-PA-IN-FR-C
    'A-PA-OUT-FR-C' : {x:70, y: 122, radius:30},   //A면 페널티 에어리어 바깥쪽 정면 부근 가운데 - A-PA-OUT-FR-C
    'A-AK-C' : {x:95, y: 122, radius:30},   //A면 아크서클 부근 가운데 - A-AK-C
    'A-MF-C' :  {x:120, y: 122, radius:30},   //A면 미드필드 부근 가운데 - A-MF-C
    'A-HL-C' : {x:150, y: 122, radius:30},   //A면 하프라인 가운데 - A-HL-C
    'B-GA-IN-GK-C' : {x:320-18, y: 122,  radius:30},   //B면 골 에어리어 안쪽 골킥 부근 가운데 - B-GA-IN-GK-C
    'B-GA-IN-C' : {x:320-27, y: 122, radius:30},   //B면 골 에어리어 안쪽 가운데 - B-GA-IN-C
    'B-GA-OUT-FR-C' : {x:320-40, y: 122, radius:30},   //B면 골 에어리어 바깥쪽 정면 부근 가운데 - B-GA-OUT-FR-C
    'B-PK-C' : {x:320-48, y: 122, radius:30},   //B면 페널티킥 부근 가운데 - B-PK-C
    'B-PA-IN-FR-C' : {x:320-57, y: 122, radius:30},   //B면 페널티 에어리어 안쪽 정면 부근 가운데 - B-PA-IN-FR-C
    'B-PA-OUT-FR-C' : {x:320-70, y: 122, radius:30},   //B면 페널티 에어리어 바깥쪽 정면 부근 가운데 - B-PA-OUT-FR-C
    'B-AK-C' : {x:320-95, y: 122, radius:30},   //B면 아크서클 부근 가운데 - B-AK-C
    'B-MF-C' : {x:320-120, y: 122, radius:30},  //B면 미드필드 부근 가운데 - B-MF-C
    'B-HL-C' : {x:320-150, y: 122, radius:30},  //B면 하프라인 가운데 - B-HL-C
    //센터 -end
    //왼쪽 -start
    'A-GA-IN-GK-L' : {x:18, y: 132, radius:30},     //A면 골 에어리어 안쪽 골킥 부근 왼쪽 - A-GA-IN-GK-L
    'A-PK-L' : {x:48, y: 132, radius:30},     //A면 페널티킥 부근 왼쪽 - A-PK-L
    'B-GA-IN-GK-L' : {x:320-18, y: 132, radius:30}, //B면 골 에어리어 안쪽 골킥 부근 왼쪽 - B-GA-IN-GK-L
    'B-PK-L' : {x:320-48, y: 132, radius:30}, //B면 페널티킥 부근 왼쪽 - B-PK-L
    'A-GA-IN-EL-L' : {x:18, y: 142, radius:30},    //A면 골 에어리어 안쪽 엔드라인 왼쪽 - A-GA-IN-EL-L
    'A-GA-IN-L' : {x:27, y: 142, radius:30},   //A면 골 에어리어 안쪽 왼쪽 - A-GA-IN-L
    'A-PA-IN-FR-L' : {x:57, y: 142, radius:30},   //A면 페널티 에어리어 안쪽 정면 부근 왼쪽 - A-PA-IN-FR-L
    'A-AK-L' : {x:95, y: 142, radius:30},   //A면 아크서클 부근 왼쪽 - A-AK-L
    'B-GA-IN-EL-L' : {x:320-18, y: 142, radius:30},    //B면 골 에어리어 안쪽 엔드라인 왼쪽 - B-GA-IN-EL-L
    'B-GA-IN-L' : {x:320-27, y: 142, radius:30},   //B면 골 에어리어 안쪽 왼쪽 - B-GA-IN-L
    'B-PA-IN-FR-L' : {x:320-57, y: 142, radius:30},   //B면 페널티 에어리어 안쪽 정면 부근 왼쪽 - B-PA-IN-FR-L
    'B-AK-L' : {x:320-95, y: 142, radius:30},   //B면 아크서클 부근 왼쪽 - B-AK-L
    'A-GA-OUT-FR-L' : {x:40, y: 160, radius:30},   //A면 골 에어리어 바깥쪽 정면 부근 왼쪽 - A-GA-OUT-FR-L
    'A-HL-L' : {x:150, y: 160, radius:30},   //A면 하프라인 왼쪽 - A-HL-L
    'B-GA-OUT-FR-L' : {x:320-40, y: 160, radius:30},   //B면 골 에어리어 바깥쪽 정면 부근 왼쪽 - B-GA-OUT-FR-L
    'B-HL-L' : {x:320-150, y: 160, radius:30},   //B면 하프라인 왼쪽 - B-HL-L
    'A-PA-IN-EL-L' : {x:18, y: 170, radius:30},    //A면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽 - A-PA-IN-EL-L
    'A-PA-OUT-FR-L' :  {x:70, y: 170, radius:30},    //A면 페널티 에어리어 바깥쪽 정면 부근 왼쪽 - A-PA-OUT-FR-L
    'A-MF-L' : {x:120, y: 170, radius:30},    //A면 미드필드 부근 왼쪽 - A-MF-L
    'B-PA-IN-EL-L' : {x:320-18, y: 170, radius:30},    //B면 페널티 에어리어 안쪽 엔드라인 부근 왼쪽 - B-PA-IN-EL-L
    'B-PA-OUT-FR-L' : {x:320-70, y: 170, radius:30},    //B면 페널티 에어리어 바깥쪽 정면 부근 왼쪽 - B-PA-OUT-FR-L
    'B-MF-L' :  {x:320-120, y: 170, radius:30},    //B면 미드필드 부근 왼쪽 - B-MF-L
    'A-PA-OUT-EL-L' : {x:18, y: 200, radius:30},    //A면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽 - A-PA-OUT-EL-L
    'A-PA-OUT-SD-L' : {x:57, y: 200, radius:30},   //A면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽 - A-PA-OUT-SD-L
    'B-PA-OUT-EL-L' : {x:320-18, y: 200, radius:30},    //B면 페널티 에어리어 바깥쪽 엔드라인 부근 왼쪽 - B-PA-OUT-EL-L
    'B-PA-OUT-SD-L' : {x:320-57, y: 200, radius:30},   //B면 페널티 에어리어 바깥쪽 사이드 부근 왼쪽 - B-PA-OUT-SD-L
    'A-PA-CK-L' : {x:33, y: 214, radius:30},   //A면 페널티 에어리어 코너 부근 왼쪽 - A-PA-CK-L
    'A-AK-TL-L' :  {x:95, y: 214, radius:30},   //A면 아크서클 터치라인 부근 왼쪽 - A-AK-TL-L
    'A-MF-TL-L' : {x:120, y: 214, radius:30},   //A면 미드필드 터치라인 부근 왼쪽 - A-MF-TL-L
    'A-HL-TL-L' : {x:150, y: 214, radius:30},   //A면 하프라인 터치라인 부근 왼쪽 - A-HL-TL-L
    'B-PA-CK-L' : {x:320-33, y: 214, radius:30},   //B면 페널티 에어리어 코너 부근 왼쪽 - B-PA-CK-L
    'B-AK-TL-L' : {x:320-95, y: 214, radius:30},   //B면 아크서클 터치라인 부근 왼쪽 - B-AK-TL-L
    'B-MF-TL-L' : {x:320-120, y: 214, radius:30},   //B면 미드필드 터치라인 부근 왼쪽 - B-MF-TL-L
    'B-HL-TL-L' : {x:320-150, y: 214, radius:30},   //B면 하프라인 터치라인 부근 왼쪽 - B-HL-TL-L
  }

  vm.playerTotalInfo = {};      //main/info 결과값을 모두 저장하는 변수
  let dateObj = new Date();
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let date = dateObj.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }
  vm.startDate = `${year}-${month}-${date}`;
  vm.endDate = `${year}-${month}-${date+1}`;

  $scope.$on('$viewContentLoaded', function(event){
    $('#startDate').each(function(){
      //   console.log($element);
      new Flatpickr(document.getElementById('startDate'), {
        minDate: "today",
        locale: Korean,
        dateFormat: 'Y-m-d',
        onChange: function(selectedDates, dateStr, instance){
          vm.startDate = selectedDates;
        }
      });
    }),
      $('#endDate').each(function(){
        new Flatpickr(this, {
          minDate: "today",
          locale: Korean,
          dateFormat: 'Y-m-d',
          onChange: function(selectedDates, dateStr, instance){
            vm.endDate = selectedDates;
          }
        });
      });
  });

  /**
   * 선수의 종합적인 생체정보 조회
   */
  let chartPadding = {
    top: 0,
    bottom: 0,
    left: 30,
    right: 5
  };

  vm.metaData = {
    movements: null,
    locations: null,
    foots: null
  };
  vm.selectedSkill = null;
  vm.selectedLocation = null;
  vm.selectedFoot = null;
  // 훈련 정보 입력에 필요한 데이터 조회
  PlanService.getTrainingMeta().then(function(data) {
    $scope.$apply(function() {
      // movements 에서 공격,수비 삭제
      _.remove(data.movements, function (movement) {
        return movement.name === '공격' || movement.name === '수비';
      });

      vm.metaData.movements = data.movements;
      vm.selectedSkill = vm.metaData.movements[0];

      //foots selectbox 셋팅
      let foots = [
        {
          id: 'all',
          name: '전체'
        },
        {
          id: 'right',
          name: '오른발'
        },
        {
          id: 'left',
          name: '왼발'
        }
      ];
      vm.metaData.foots = foots;
      vm.selectedFoot = vm.metaData.foots[0];
    });
  });

  //경기장 위치 데이터 조회
  AnalysisService.getLocationList().then(function(data){
    $scope.$apply(function() {
      vm.metaData.locations = data.data;
      vm.metaData.locations.unshift({id: 0, name: '전체'});
      vm.selectedLocation = vm.metaData.locations[0];
    });
  });

  vm.getPlayerBiometricInfo  = function(mode){
    $('.loading').show();
    $scope.mode = mode;
    vm.userInfo.mode = mode;

    PlayerService.getPlayerBiometricInfo(vm.userInfo).then(function(data){
      $scope.$apply(function(){
        vm.playerTotalInfo = data;
        setMainPagePlayerInfo();
        $scope.$watchGroup(['playerMain.selectedSkill','playerMain.selectedLocation','playerMain.selectedFoot'],function(newVal, oldVal) {
          vm.setMovementsInfo(newVal);
        });
        vm.playerSkillData = data;
        let skillKeyName = 'skill';
        let targetId = '#player-skill-main-chart';

        $('.loading').hide();
      });
    }, function(err){
      console.log('getPlayerBiometricInfo err : ', err)
    });
  };

  let liquidGaugeSize = {
    width: '90px',
    height: '90px'
  };

  /**
   * 심박수 선택값 세팅
   */
  let heartbeatMainChart;
  vm.setHeartbeatInfo = function(type,subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.heartbeat = type;
    let unit = (type=='max'||type=='stable'||type=='current')?'bpm':((type=='recovery')?'%':'초');
    let value = vm.playerTotalInfo.heartbeat[0][type];

    let heartbeatKeyName = 'heartbeat';
    let targetId = '#player-heartbeat-main-chart';
    if(type=='reach'||type=='recovery'||type=='stable'){
      $scope.heartbeatSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.heartbeat[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(heartbeatMainChart.type == 'liquid'){
        heartbeatMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!heartbeatMainChart){
        heartbeatMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        heartbeatMainChart.diameter(90).value(chartValue).render();
        heartbeatMainChart['type'] = 'raidal';
      }else{
        heartbeatMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      let max = 220 - 38;

      if(!heartbeatMainChart || heartbeatMainChart.type == 'raidal'){
        heartbeatMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart

      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'heartbeat-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      let dataValue = (value/max) * 100;
      if(!heartbeatMainChart){
        heartbeatMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        heartbeatMainChart['type'] = 'liquid';
      }else{
        heartbeatMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '심박수',
      value,
      unit
    }
    vm.playerHeartbeatData = data;

    //line chart
    let heartbeatColumnData = [heartbeatKeyName]
    let heartbeatData = vm.playerTotalInfo.heartbeat[0].data;
    for(let i=0;i<heartbeatData.length;i++){
      heartbeatColumnData.push(heartbeatData[i].value);
    }

    let heartRateType = {};
    heartRateType[heartbeatKeyName] = 'area-spline';

    let heartbeatChartOptions = {
      targetId: '#player-heartbeat-line-chart',
      padding: chartPadding,
      columnData: heartbeatColumnData,
      type: heartRateType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //heart-rate line chart
    let heartbeatOptions = ChartGeneratorService.setLineChartOptions(heartbeatChartOptions);
    ChartGeneratorService.generateLineChart(heartbeatOptions)
  };

  /**
   * 거리 선택값 세팅
   */
  let distanceMainChart;
  let distanceChartType;
  vm.setDistanceInfo = function(type,subType) {
    //type : max(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.distance = type;
    let value = vm.playerTotalInfo.distance[0][type];

    let distanceKeyName = 'distance';
    let targetId = '#player-distance-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.distanceSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.distance[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(distanceChartType == 'gauge'){
        distanceMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!distanceMainChart){
        distanceMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        distanceMainChart.diameter(90).value(chartValue).render();
        distanceChartType = 'raidal';
      }else{
        distanceMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      if(!distanceMainChart || distanceChartType == 'raidal'){
        distanceMainChart = null;
        $(targetId).html('');
      }

      if(!distanceMainChart){
        let configuration = {
          size: 165,
          clipWidth: 158,
          clipHeight: 100,
          ringWidth: 30,
          maxValue: 60,
          transitionMs: 4000,
        }
        distanceMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
        distanceMainChart.render();
        distanceChartType = 'gauge';
      }
      distanceMainChart.update(value);
    }

    let data = {
      title: '거리',
      value: value,
      unit: 'km'
    }
    vm.playerDistanceData = data

    //line chart
    let distanceColumnData = [distanceKeyName]
    let distanceData = vm.playerTotalInfo.distance[0].data;
    for(let i=0;i<distanceData.length;i++){
      distanceColumnData.push(distanceData[i].value);
    }

    let distanceType = {};
    distanceType[distanceKeyName] = 'spline';

    let distanceChartOptions = {
      targetId : '#player-distance-chart',
      padding : chartPadding,
      columnData : distanceColumnData,
      type: distanceType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-distance line chart
    let distanceOptions = ChartGeneratorService.setLineChartOptions(distanceChartOptions);
    ChartGeneratorService.generateLineChart(distanceOptions);
  };

  /**
   * 부상 선택값 세팅
   */
  vm.setInjuryInfo = function(type) {
    //type : norm(정상),recovery(회복),cure(치료),operation(수술),current(현재)
    $scope.injury = type;
    let data = {
      title: vm.playerTotalInfo.injury[0][type].status,
      value: vm.playerTotalInfo.injury[0][type].day,
      unit : 'day'
    };
    vm.playerinjuryData = data;

    let player_injury = vm.playerTotalInfo.injury[0].part + ' ' + vm.playerTotalInfo.injury[0].category;
    let injurylabel = d3.select('#player-injury-label-svg')
      .append('g')
      .attr('transform','translate(150, 30)').append('text');
    injurylabel.html('');         //remove existant text
    injurylabel.insert('tspan').text(player_injury).attr('class','heat-title-label');
  };

  /**
   * 산소 선택값 세팅
   */
  let oxygenMainChart;
  vm.setOxygenInfo = function(type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.oxygen = type;
    let unit = (type=='max'||type=='stable'||type=='current'||type=='recovery')?'%':'초';
    let value = vm.playerTotalInfo.oxyzen[0][type];

    let oxygenKeyName = 'oxygenData';
    let targetId = '#player-oxygen-main-chart';
    if(type=='reach'||type=='recovery'||type=='stable'){
      $scope.oxygenSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.oxyzen[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(oxygenMainChart.type == 'liquid'){
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!oxygenMainChart){
        oxygenMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        oxygenMainChart.diameter(90).value(value).render();
        oxygenMainChart['type'] = 'raidal';
      }else{
        oxygenMainChart.diameter(90).value(value).render();
      }
    }else{
      if(!oxygenMainChart || oxygenMainChart.type == 'raidal'){
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'oxygen-liquid';
      options.circleColor = '#3187c5';
      options.textColor = '#3187c5';
      options.waveColor = '#3187c5';
      options.size = liquidGaugeSize;
      if(!oxygenMainChart){
        oxygenMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
        oxygenMainChart['type'] = 'liquid';
      }else{
        oxygenMainChart.update(value);
      }
    }
    let data = {
      title: 'Sp02',
      value,
      unit
    };
    vm.playerOxygenData = data;

    //line chart
    let oxygenColumnData = [oxygenKeyName]
    let oxyzenData = vm.playerTotalInfo.oxyzen[0].data;
    for(let i=0;i<oxyzenData.length;i++){
      oxygenColumnData.push(oxyzenData[i].value);
    }

    let oxygenType = {};
    oxygenType[oxygenKeyName] = 'spline';

    let oxygenChartOptions = {
      targetId: '#player-oxygen-line-chart',
      padding: chartPadding,
      columnData: oxygenColumnData,
      type: oxygenType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };
    //player-oxygen line chart
    let oxygenOptions = ChartGeneratorService.setLineChartOptions(oxygenChartOptions);
    ChartGeneratorService.generateLineChart(oxygenOptions);
  };

  /**
   * 속도 선택값 세팅
   */
  let velocityMainChart;
  let velocityChartType;
  vm.setVelocityInfo = function(type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    //   vm.playerTotalInfo.velocity[0].current = 15;
    //   vm.playerTotalInfo.velocity[0].target = 30;
    //   vm.playerTotalInfo.velocity[0].max = 25;
    //   vm.playerTotalInfo.velocity[0].reach = 45;
    //   vm.playerTotalInfo.velocity[0].average = 20;
    $scope.velocity = type;
    let value = vm.playerTotalInfo.velocity[0][type];

    let velocityKeyName = 'velocity';
    let targetId = '#player-velocity-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.velocitySubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.velocity[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(velocityChartType == 'gauge'){
        velocityMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!velocityMainChart){
        velocityMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        velocityMainChart.diameter(90).value(chartValue).render();
        velocityChartType = 'raidal';
      }else{
        velocityMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      if(!velocityMainChart || velocityChartType == 'raidal'){
        velocityMainChart = null;
        $(targetId).html('');
      }

      if(!velocityMainChart){
        let configuration = {
          size: 165,
          clipWidth: 158,
          clipHeight: 100,
          ringWidth: 30,
          maxValue: 60,
          transitionMs: 4000,
        }
        velocityMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
        velocityMainChart.render();
        velocityChartType = 'gauge';
      }
      velocityMainChart.update(value);
    }
    let data = {
      title: '속도',
      value: value,
      unit: 'm/s'
    };
    vm.playerVelocityData = data;

    //line chart
    let veleocityColumnData = [velocityKeyName];
    let velocityData = vm.playerTotalInfo.velocity[0].data;
    for(let i=0;i<velocityData.length;i++){
      veleocityColumnData.push(velocityData[i].value);
    }

    let velocityType = {};
    velocityType[velocityKeyName] = 'spline'

    let velocityChartOptions = {
      targetId: '#player-velocity-line-chart',
      padding: chartPadding,
      columnData: veleocityColumnData,
      type: velocityType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-velocity line chart
    let velocityOptions = ChartGeneratorService.setLineChartOptions(velocityChartOptions);
    ChartGeneratorService.generateLineChart(velocityOptions);
  };

  /**
   * 칼로리섭취 선택값 세팅
   */
  let caloryGetMainChart;
  vm.setCaloryGetInfo = function(type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryget = type;
    let value = vm.playerTotalInfo.calrorie_get[0][type];

    let caloryKeyName = 'calory';
    let targetId = '#player-calory-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.calorygetSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_get[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(caloryGetMainChart.type == 'liquid'){
        caloryGetMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!caloryGetMainChart){
        caloryGetMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        caloryGetMainChart.diameter(90).value(132).render();
        caloryGetMainChart['type'] = 'raidal';
      }else{
        caloryGetMainChart.diameter(90).value(170).render();
      }
    }else{
      let max = vm.playerTotalInfo.calrorie_get[0].max;
      let dataValue;
      if(max == 0){
        max = 100;
        dataValue = 0;
      }else{
        dataValue = (value/max) * 100;
      }

      if(!caloryGetMainChart || caloryGetMainChart.type == 'raidal'){
        caloryGetMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-calory-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if(!caloryGetMainChart){
        caloryGetMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        caloryGetMainChart['type'] = 'liquid';
      }else{
        caloryGetMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '칼로리섭취',
      value: number_format(value),
      unit : 'kcal'
    };
    vm.playerCaloryData = data;

    //line chart
    let caloryColumnData = [caloryKeyName];
    let caloryData = vm.playerTotalInfo.calrorie_get[0].data;
    for(let i=0;i<caloryData.length;i++){
      caloryColumnData.push(caloryData[i].value);
    }

    let caloryType = {};
    caloryType[caloryKeyName] = 'spline';

    let caloryChartOptions = {
      targetId: '#player-calory-line-chart',
      padding: chartPadding,
      columnData: caloryColumnData,
      type: caloryType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryOptions = ChartGeneratorService.setLineChartOptions(caloryChartOptions);
    ChartGeneratorService.generateLineChart(caloryOptions);
  };

  /**
   * 젖산 선택값 세팅
   */
  let lacticMainChart;
  vm.setLacticInfo = function(type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.lactic = type;
    let unit = (type=='max'||type=='stable'||type=='current')?'mg/dℓ':((type=='recovery')?'%':'초');
    let value = vm.playerTotalInfo.lactic[0][type];

    let lacticKeyName = 'lactic';
    let targetId = '#player-lactic-main-chart';
    if(type=='reach'||type=='stable'||type=='recovery'){
      $scope.lacticSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.lactic[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(lacticMainChart.type == 'liquid'){
        lacticMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!lacticMainChart){
        lacticMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        lacticMainChart.diameter(90).value(chartValue).render();
        lacticMainChart['type'] = 'raidal';
      }else{
        lacticMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      let max = vm.playerTotalInfo.lactic[0].max;
      if(max == 0){
        max = 10;
      }

      if(!lacticMainChart || lacticMainChart.type == 'raidal'){
        lacticMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'lactic-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if(!lacticMainChart){
        lacticMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
        lacticMainChart['type'] = 'liquid';
      }else{
        lacticMainChart.update(value);
      }
    }

    let data = {
      title: '젖산',
      value,
      unit
    };
    vm.playerLacticData = data;

    //line chart
    let lacticColumnData = [lacticKeyName];
    let lacticData = vm.playerTotalInfo.lactic[0].data;
    for(let i=0;i<lacticData.length;i++){
      lacticColumnData.push(lacticData[i].value);
    }

    let lacticType = {};
    lacticType[lacticKeyName] = 'spline';

    let lacticChartOptions = {
      targetId: '#player-lactic-line-chart',
      padding: chartPadding,
      columnData: lacticColumnData,
      type: lacticType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-lactic line chart
    let lacticOptions = ChartGeneratorService.setLineChartOptions(lacticChartOptions);
    ChartGeneratorService.generateLineChart(lacticOptions);
  };

  /**
   * 체중 선택값 세팅
   */
  let weightMainChart;
  let weightChartType;
  vm.setWeightInfo = function(type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.weight = type;
    let value = vm.playerTotalInfo.weight[0][type];

    let weightKeyName = 'weight';
    let targetId = 'player-weight-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.weightSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.lactic[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(weightChartType == 'gauge'){
        weightMainChart = null;
        $('#player-weight-main-chart').html('');
      }
      //radial progress bar chart
      if(!weightMainChart){
        weightMainChart = ChartGeneratorService.updateRadialProgress('#player-weight-main-chart');
        weightMainChart.diameter(90).value(chartValue).render();
        weightChartType = 'raidal';
      }else{
        weightMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      if(!weightMainChart || weightChartType == 'raidal'){
        weightMainChart = null;
        $('#player-weight-main-chart').html('');
      }
      /* weight gauges chart */
      if(!weightMainChart){
        let size = 150;
        weightMainChart = ChartGeneratorService.createGaugeChart(targetId, weightKeyName, size);
        weightChartType = 'gauge';
      }
      ChartGeneratorService.updateGaugeChart(value, weightMainChart, targetId);
    }

    let data = {
      title: '체중',
      value,
      unit: 'kg'
    };
    vm.playerWeightData = data;

    //line chart
    let weightColumnData = [weightKeyName];
    let weightData = vm.playerTotalInfo.weight[0].data;
    for(let i=0;i<weightData.length;i++){
      weightColumnData.push(weightData[i].value);
    }

    let weightType = {};
    weightType[weightKeyName] = 'spline';
    let weightChartOptions = {
      targetId: '#player-weight-line-chart',
      padding: chartPadding,
      columnData: weightColumnData,
      type: weightType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-weight line chart
    let weightOptions = ChartGeneratorService.setLineChartOptions(weightChartOptions);
    ChartGeneratorService.generateLineChart(weightOptions);
  };

  /**
   * 체온 선택값 세팅
   */
  let temperatureMainChart;
  let temperatureChartType;
  vm.setTemperatureInfo = function(type, subType) {

    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.temperature = type;
    let unit = (type=='max'||type=='stable'||type=='current')?'℃':((type=='recovery')?'%':'초');
    let value = vm.playerTotalInfo.temperature[0][type];

    let temperatureKeyName = 'temperature';
    let targetId = '#player-temperature-main-chart';
    if(type=='reach'||type=='stable'||type=='recovery'){
      $scope.temperatureSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.temperature[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(temperatureChartType == 'meter'){
        temperatureMainChart = null;
        $(targetId).html('');
      }
      //radial progress bar chart
      if(!temperatureMainChart){
        temperatureMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        temperatureMainChart.diameter(90).value(chartValue).render();
        temperatureChartType = 'raidal';
      }else{
        temperatureMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      if(!temperatureMainChart || temperatureChartType == 'raidal'){
        temperatureMainChart = null;
        $(targetId).html('');
      }

      let thermometerOptions = {
        targetId: targetId,
        svg_height: 100,
        svg_width: 100,
        svg_style: 'padding-top:3px;',
        max_temp: 44,
        min_temp: 32,
        current_temp: value,
        topY: 5,
        bulb_radius: 12,
        tube_width: 13,
        tube_border_width: 1,
      };
      ChartGeneratorService.createThermometer(thermometerOptions);
      temperatureChartType = 'meter';
    }

    let data = {
      title: '체온',
      value,
      unit
    };
    vm.playerTemperatureData = data;

    //line chart
    let temperatureColumnData = [temperatureKeyName];
    let temperatureData = vm.playerTotalInfo.temperature[0].data;
    for(let i=0;i<temperatureData.length;i++){
      temperatureColumnData.push(temperatureData[i].value);
    }

    let temperatureType = {};
    temperatureType[temperatureKeyName] = 'spline';

    let temperatureChartOptions = {
      targetId: '#player-temperature-line-chart',
      padding: chartPadding,
      columnData: temperatureColumnData,
      type: temperatureType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-temperature line chart
    let temperatureOptions = ChartGeneratorService.setLineChartOptions(temperatureChartOptions);
    ChartGeneratorService.generateLineChart(temperatureOptions);
  }

  /**
   * 수면 선택값 세팅
   */
  let sleepMainChart;
  vm.setSleepInfo = function(type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.sleep = type;
    let max = vm.playerTotalInfo.sleep[0].max.hour*60 + vm.playerTotalInfo.sleep[0].max.minute;
    if(max == 0){
      max = 1440;
    }
    max = 1440
    let hour = vm.playerTotalInfo.sleep[0][type].hour;
    let minute = vm.playerTotalInfo.sleep[0][type].minute;
    let value = ((hour*60) + minute)/max * 100;

    let sleepKeyName = 'sleep';
    let targetId = '#player-sleep-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.sleepSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.sleep[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(sleepMainChart.type == 'liquid'){
        sleepMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!sleepMainChart){
        sleepMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        sleepMainChart.diameter(90).value(132).render();
        sleepMainChart['type'] = 'raidal';
      }else{
        sleepMainChart.diameter(90).value(170).render();
      }
    }else{
      if(!sleepMainChart || sleepMainChart.type == 'raidal'){
        sleepMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'sleep-liquid';
      options.circleColor = '#27f72d';
      options.textColor = '#27f72d';
      options.waveColor = '#27f72d';
      options.size = liquidGaugeSize;
      if(!sleepMainChart){
        sleepMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(value), options);
        sleepMainChart['type'] = 'liquid';
      }else{
        sleepMainChart.update(Math.round(value));
      }
    }

    let data = {
      title: '수면',
      hour,
      hourUnit: '시간',
      minute,
      minuteUnit: '분'
    }
    vm.playerSleepData = data;

    //line chart
    let sleepColumnData = [sleepKeyName];
    let sleepeData = vm.playerTotalInfo.sleep[0].data;
    for(let i=0;i<sleepeData.length;i++){
      sleepColumnData.push(sleepeData[i].value);
    }

    let sleepType = {};
    sleepType[sleepKeyName] = 'spline';

    let sleepChartOptions = {
      targetId: '#player-sleep-line-chart',
      padding: chartPadding,
      columnData: sleepColumnData,
      type: sleepType,
      color: '#27f72d',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //sleep line chart
    let sleepOptions = ChartGeneratorService.setLineChartOptions(sleepChartOptions);
    ChartGeneratorService.generateLineChart(sleepOptions);
  }

  /**
   * 칼로리섭취 선택값 세팅
   */
  let caloryBurnMainChart;
  vm.setCaloryBurnInfo = function(type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryburn = type;
    let value = vm.playerTotalInfo.calrorie_burned[0][type];

    let caloryBurnKeyName = 'caloryburn';
    let targetId = '#player-burn-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.caloryburnSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_burned[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(caloryBurnMainChart.type == 'liquid'){
        caloryBurnMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!caloryBurnMainChart){
        caloryBurnMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        caloryBurnMainChart.diameter(90).value(chartValue).render();
        caloryBurnMainChart['type'] = 'raidal';
      }else{
        caloryBurnMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      let max = vm.playerTotalInfo.calrorie_burned[0].max;
      let dataValue;
      if(max == 0){
        max = 100;
        dataValue = 0;
      }else{
        dataValue = (value/max) * 100;
      }

      if(!caloryBurnMainChart || caloryBurnMainChart.type == 'raidal'){
        caloryBurnMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-burn-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if(!caloryBurnMainChart){
        caloryBurnMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        caloryBurnMainChart['type'] = 'liquid';
      }else{
        caloryBurnMainChart.update(Math.round(dataValue));
      }
    }
    let data = {
      title: '칼로리소모',
      value: number_format(value),
      unit : 'kcal'
    };
    vm.playerBurnData = data;

    //line chart
    let caloryBurnColumnData = [caloryBurnKeyName];
    let caloryBurnData = vm.playerTotalInfo.calrorie_burned[0].data;
    for(let i=0;i<caloryBurnData.length;i++){
      caloryBurnColumnData.push(caloryBurnData[i].value);
    }

    let caloryBurnType = {};
    caloryBurnType[caloryBurnKeyName] = 'spline';

    let caloryBurnChartOptions = {
      targetId: '#player-burn-line-chart',
      padding: chartPadding,
      columnData: caloryBurnColumnData,
      type: caloryBurnType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryBurnOptions = ChartGeneratorService.setLineChartOptions(caloryBurnChartOptions);
    ChartGeneratorService.generateLineChart(caloryBurnOptions);
  }


  /**
   * 수분 선택값 세팅
   */
  let waterMainChart;
  vm.setWaterInfo = function(type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.water = type;

    let value = vm.playerTotalInfo.water[0][type];
    let max = vm.playerTotalInfo.water[0].max;
    if(max == 0){
      max = 100;
    }

    let waterKeyName = 'water';
    let targetId = '#player-water-main-chart';
    if(type=='reach'||type=='stable'||type=='average'){
      $scope.waterSubType = subType;
      let chartValue = 0;
      if(type == 'reach'){  //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.water[0][subType];
        chartValue = (value/subValue) * 100;
      }else{                //
        chartValue = value;
      }

      if(Number.isNaN(chartValue)){
        chartValue = 0;
      }

      if(waterMainChart.type == 'liquid'){
        waterMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if(!waterMainChart){
        waterMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        waterMainChart.diameter(90).value(chartValue).render();
        waterMainChart['type'] = 'raidal';
      }else{
        waterMainChart.diameter(90).value(chartValue).render();
      }
    }else{
      if(!waterMainChart || waterMainChart.type == 'raidal'){
        waterMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'water-liquid';
      options.circleColor = '#3187c5';
      options.textColor = '#3187c5';
      options.waveColor = '#3187c5';
      options.size = liquidGaugeSize;
      let dataValue = value/max * 100;
      if(!waterMainChart){
        waterMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        waterMainChart['type'] = 'liquid';
      }else{
        waterMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '수분',
      value: number_format(value),
      unit: 'ml'
    };
    vm.playerWaterData  = data;

    //line chart
    let waterColumnData = [waterKeyName];
    let waterData = vm.playerTotalInfo.water[0].data;
    for(let i=0;i<waterData.length;i++){
      waterColumnData.push(waterData[i].value);
    }

    let waterType = {};
    waterType[waterKeyName] = 'spline';

    let waterChartOptions = {
      targetId: '#player-water-line-chart',
      padding: chartPadding,
      columnData: waterColumnData,
      type: waterType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //heart-rate line chart
    let waterOptions = ChartGeneratorService.setLineChartOptions(waterChartOptions);
    ChartGeneratorService.generateLineChart(waterOptions)
  }


  // 히트맵 탭 클릭
  vm.changeHeatmapTab = function(mode){
    vm.activeHeatmapTab = mode;
    vm.setMovementsInfo([vm.selectedSkill,vm.selectedLocation,vm.selectedFoot]);
  };


  let locationNum = 0;
  let heatmapInstance;
  vm.setMovementsInfo = function(selectedData) {
    console.log('selectedData ...........', selectedData);
    let skillIdx = $('#movement option').index($('#movement option:selected'));
    let data = {
      name: vm.playerTotalInfo.movements[skillIdx].name,
      total: vm.playerTotalInfo.movements[skillIdx].total,
      success: vm.playerTotalInfo.movements[skillIdx].suc,
      right: vm.playerTotalInfo.movements[skillIdx].right,
      left: vm.playerTotalInfo.movements[skillIdx].left
    };
    vm.playerSkillData = data;
    let skillKeyName = 'skill';
    let targetId = '#player-skill-main-chart';

    $(targetId).html('');
    let successPer = (data.success/data.total) * 100;
    if(Number.isNaN(successPer)){
      successPer = 0; //임시 값 제거
    }
    let rightPer = (data.right/(data.right + data.left)) * 100;
    if(Number.isNaN(rightPer)){
      rightPer = 0; //임시 값 제거
    }

    let dataset =[
      {
        data:[
          {
            title: '성공',
            count: successPer     //성공
          },
          {
            title: '발',
            count: rightPer     //오른발
          }
        ]
      },
      {
        data: [
          {
            title: '성공',
            count: 100 - successPer     //실패
          },
          {
            title: '발',
            count: successPer - rightPer     //왼발
          }
        ]
      }
    ];
    console.log('dataset', dataset);
    ChartGeneratorService.createStackedBarChartHoriz(targetId,dataset);

    let locData = {
      name: selectedData[1].name
    };
    vm.playerLocationData = locData;
    let locationKeyName = 'location';
    let locations = vm.playerTotalInfo.locations;

    var points = [];

    if(selectedData[1].id){
      var targetObj = angular.copy(vm.heatmapPos[selectedData[1].abbr]);
      var targetLoc = _.find(locations,{abbr:selectedData[1].abbr});

      if(vm.activeHeatmapTab=='suc'){
        targetObj['value'] = targetLoc.top_suc + targetLoc.right_suc + targetLoc.left_suc + targetLoc.bottom_suc;
      }else{
        targetObj['value'] = targetLoc.top_att + targetLoc.right_att + targetLoc.left_att + targetLoc.bottom_att;
      }

      // 임시데이터 삽입
      targetObj['value'] = Math.floor((Math.random() * 100) + 1);
      points.push(targetObj);
    }else{
      _.forEach(locations,function(o){
        var targetObj = angular.copy(vm.heatmapPos[o.abbr]);
        // console.log('targetObj 000....', targetObj);
        if(targetObj){
          if(vm.activeHeatmapTab=='suc'){
            targetObj['value'] = o.top_suc + o.right_suc + o.left_suc + o.bottom_suc;
          }else{
            targetObj['value'] = o.top_att + o.right_att + o.left_att + o.bottom_att;
          }

          // 임시데이터 삽입
          if(targetObj['value'] <= 0){
            targetObj['value'] = Math.floor((Math.random() * 100) + 1);
          }
          // console.log('targetObj 111....', targetObj);
          points.push(targetObj);
        }
      });
    }

    // console.log('locatons > ', locations);

    //minimal heatmap instance configuration
    if(!heatmapInstance){
      heatmapInstance = h337.create({
        container: document.querySelector('.heatmap')
      });
    };

    //generate data
    //   let points = [{x:80, y: 80, value:95, radius:20},{x:40, y: 80, value:45, radius:20}
    //                 ,{x:60, y: 90, value:70, radius:20},{x:80, y: 90, value:45, radius:20}
    //                 ,{x:80, y: 100, value:59, radius:20},{x:80, y: 100, value:88, radius:20}
    //                 ,{x:80, y: 110, value:59, radius:20},{x:80, y: 110, value:88, radius:20}
    //                  ,{x:100, y: 90, value:70, radius:20},{x:110, y: 90, value:45, radius:20}
    //                 ,{x:120, y: 100, value:59, radius:20},{x:130, y: 100, value:88, radius:20}
    //                 ,{x:140, y: 110, value:59, radius:20},{x:150, y: 110, value:88, radius:20}];
    //   let max = 0;
    //   let width = 200;
    //   let height = 200

    console.log('points......', points);

    let locationData = {
      max : 100,
      data : points
    };
    heatmapInstance.removeData();
    heatmapInstance.setData(locationData);

    //line chart
    let skillColumnData = [skillKeyName];
    let skillData = vm.playerTotalInfo.lactic[0].data;
    for(let i=0;i<skillData.length;i++){
      skillColumnData.push(skillData[i].value);
    }

    let skillType = {};
    skillType[skillKeyName] = 'spline';

    let skillChartOptions = {
      targetId: '#player-skill-line-chart',
      padding: chartPadding,
      columnData: skillColumnData,
      type: skillType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-skill line chart
    let skillOptions = ChartGeneratorService.setLineChartOptions(skillChartOptions);
    ChartGeneratorService.generateLineChart(skillOptions);
  }

  /**
   * player-main 화면 선수(개인)정보 세팅
   */
  function setMainPagePlayerInfo(){
    if(vm.userInfo.mode == 'recent'){
      /**
       * 선수 포지션 표시
       */
      let positionClass = vm.playerTotalInfo.position;
      let backNumber = vm.playerTotalInfo.back_number;
      let playerName = vm.playerTotalInfo.name;
      let cssKey = 'margin-left';
      if(positionClass == 'FW-RWF' || positionClass == 'MF-RWM' || positionClass == 'MF-RM' || positionClass == 'DF-RWB' || positionClass == 'DF-RB'){
        cssKey = 'margin-right';
      }

      let positionHtmlElement = `<span style="position: absolute; ${cssKey}:-30px" class=${positionClass}><strong>${backNumber}</strong>${playerName}</span>`;
      $("#player-field-position").html(positionHtmlElement);

      /**
       * 기본정보 세팅
       * 경기일자/시간/명칭/상대팀명/경기장/날씨/습도/기온/바람
       * 고도/잔디/총경기/총전적/득점/실점/도움/경고/퇴장
       */
      if(vm.playerTotalInfo.game_info){
        vm.playerGameInfo = vm.playerTotalInfo.game_info[0];
      }
      vm.playerRecordInfo = vm.playerTotalInfo.game_record[0];
    }
    /**
     * 선수생체 정보 세팅
     * 심박수/거리/부상/산소포화도/속도/칼로리섭취/젖산/체중/체온/수면/칼로리소모/수분
     */
    vm.setHeartbeatInfo('current');        //heartbeat
    vm.setVelocityInfo('current');         //velocity
    vm.setInjuryInfo('current');           //injury
    vm.setOxygenInfo('current');           //Sp02
    vm.setCaloryBurnInfo('current');       //calory_burn
    vm.setCaloryGetInfo('current');        //caloryGet
    vm.setLacticInfo('current');           //lactic
    //   vm.setMovementsInfo('current');        //movements
    vm.setWeightInfo('current');           //weight
    vm.setTemperatureInfo('current');      //temperature
    vm.setSleepInfo('current');            //sleep
    vm.setWaterInfo('current');            //water
    //   vm.setLocationInfo('current');         //location
    vm.setDistanceInfo('current');         //distance
  }

  /* 메인화면 선수 생체정보 데이터 및 차트 초기화 */
  vm.getPlayerBiometricInfo('recent');
}

export default {
  name: 'Main2Ctrl',
  fn: Main2Ctrl
};
